import { filter, findIndex, forEach } from 'lodash-es';
import qs from 'qs';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import MainButtonSet from '../../components/mainButtonSet';
import Pager from '../../components/pager';
import Pagination from '../../components/pagination';
import PayBalance from '../../components/payBalance';
import StageHeader from '../../components/stageHeader';
import UnisDefaultSelect from '../../components/unisDefaultSelect';
import UnisProductModal from '../../components/unisProductModal';
import WaitingButton from '../../components/waiting-button/waiting-button.vue';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import { analytics } from '../../services/analytics';
import switchBillingToService from '../../shared/switchBillingToService';
import util from '../../shared/util';
import template from './invoices.vue';

function download(filename: string, blob: Blob): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

@Component({
    mixins: [template],
    components: {
        StageHeader,
        MainButtonSet,
        UnisDefaultSelect,
        UnisProductModal,
        Pagination,
        Pager,
        PayBalance,
        WaitingButton,
    },
})
export default class Invoices extends Vue {
    truckloadForm: any = {};
    editProductModal: string = 'payBalance';
    foldBody: number = 0;
    invoicesArr: any = {};
    searchStatus: any = '';
    searchParams: any = {
        page_size: 10,
        page: 1,
        search_term: '',
        status_array: [],
        order_by: '',
    };
    sortDueDate: any = 0;
    orderId: any = '';
    sortStatus: any = 0;
    paging: any = {
        pageSize: 10,
        currentPage: 1,
        totalSize: 0,
        text: 'invoices',
    };
    billto_id: any = '';
    statusArr: any = [
        { value: 'all', label: 'All' },
        { value: '1', label: 'OUTSTANDING' },
        { value: '2', label: 'PAID' },
        { value: '3', label: 'PAST_DUE' },
    ];
    chooseInvoiceArr: any = [];
    isSelectAll: Boolean = false;
    isGetInvoicesListByStatusArray: Boolean = false;
    payInvoice: any = [];
    payOptionVal: any = 1;
    outstandingList: any = [];
    payTitle: string = 'Pay for selected invoices';
    totalBalance: any = 0;
    outstandingBalance: any = 0;
    fromStatusArray: any = null;
    isGettingInvoicesList = false;

    isExportingData = false;

    showFields = {
        Invoice: true,
        Pro: true,
        'Invoice date': true,
        'Due date': true,
        Status: true,
        'Total amount': true,
        Balance: true,
    };

    supportedFields = [
        {
            field: 'invoice_no',
            key: 'Invoice',
            label: 'Invoice#',
        },

        {
            field: 'pro',
            key: 'Pro',
            label: 'Pro',
        },

        {
            field: 'invoice_date',
            key: 'Invoice date',
            label: 'Issue date',
        },

        {
            field: 'invoice_duedate',
            key: 'Due date',
            label: 'Due date',
        },

        {
            field: 'status_text',
            key: 'Status',
            label: 'Status',
        },

        {
            field: 'invoice_total',
            key: 'Total amount',
            label: 'Total amount',
        },

        {
            field: 'balance',
            key: 'Balance',
            label: 'Balance',
        },
    ];

    async mounted() {
        await this.getCustomerData();

        const { referer } = this.$route.query;
        if (referer === 'bnp_debt_email') {
            this.fromStatusArray = ['1', '3'];
            this.isGetInvoicesListByStatusArray = true;
        } else {
            this.fromStatusArray = null;
            this.isGetInvoicesListByStatusArray = false;
        }

        const from = this.$route.params.from;
        if (from == '13') {
            this.fromStatusArray = ['1', '3'];
            this.isGetInvoicesListByStatusArray = true;
        } else {
            this.isGetInvoicesListByStatusArray = false;
        }

        this.getInvoicesList(1);
        this.getAllOutStanding();
    }

    editProductAction(modalName: any) {
        this.editProductModal = modalName;
        this.$modal.show(modalName);
    }

    closeModal() {
        if (this.chooseInvoiceArr.length == 1 || this.payInvoice.length == 1) {
            this.payInvoice = [];
        }
        this.$modal.hide(this.editProductModal);
    }

    getList(page: any) {
        this.paging.pageSize = page.pageSize;
        this.getInvoicesList(page.currentPage);
    }

    countAmount() {
        this.totalBalance = 0;
        this.outstandingBalance = 0;
        let pastDues = filter(this.outstandingList, { status_text: 'Past due' });
        let outStandings = filter(this.outstandingList, {
            status_text: 'Outstanding',
        });
        forEach(outStandings, (item: any) => {
            let pBalance: any = 0;
            pBalance = item.balance;
            this.totalBalance += Number(pBalance);
        });
        this.totalBalance = this.totalBalance.toFixed(2);

        forEach(pastDues, (item: any) => {
            let peBalance: any = 0;
            peBalance = item.balance;
            this.outstandingBalance += Number(peBalance);
        });
        this.outstandingBalance = this.outstandingBalance.toFixed(2);
    }

    getInvoicesList(page: number) {
        this.searchParams.page = page;
        if (this.isGetInvoicesListByStatusArray) {
            this.searchParams.status_array = this.fromStatusArray;
        } else {
            this.searchParams.status_array = [];
            if (this.fromStatusArray && this.fromStatusArray.length > 0) {
                this.searchParams.status_array = this.fromStatusArray;
            } else if (this.searchStatus && this.searchStatus != 'all') {
                this.searchParams.status_array.push(this.searchStatus);
            }
        }
        this.searchParams.page_size = this.paging.pageSize;
        this.searchParams.billto_id = this.billto_id;
        this.isSelectAll = false;
        this.isGettingInvoicesList = true;
        tmsServiceBackend.get(`/tms/invoices/list_v2?${qs.stringify(this.searchParams)}`).then(
            (res: any) => {
                this.invoicesArr = res.data.data.details;
                this.paging.currentPage = res.data.data.page.current_page;
                this.paging.totalSize = res.data.data.page.total_num;
                this.chooseInvoiceArr = [];
                this.chooseInvoiceArr = [];
                this.payInvoice = [];
                this.invoicesArr.forEach((item: any) => {
                    item.showOption = false;
                });
                this.isGettingInvoicesList = false;
                this.$forceUpdate();
            },
            (err: any) => {
                console.log(err);
                this.isGettingInvoicesList = false;
            }
        );
    }

    /**
     * calculate outstanding balance and past due balance
     */
    getAllOutStanding() {
        const params: any = {
            page_size: 999999,
            status_array: ['1', '3'],
            billto_id: this.billto_id,
        };
        tmsServiceBackend.get(`/tms/invoices/list?${qs.stringify(params)}`).then(
            (res: any) => {
                this.outstandingList = res.data.data.details;
                this.countAmount();
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    chooseItem(item: any) {
        if (item.isSelect) {
            item.isSelect = false;
            let index = findIndex(this.chooseInvoiceArr, (o: any) => {
                return o.invoice_no == item.invoice_no;
            });
            this.chooseInvoiceArr.splice(index, 1);
            this.payInvoice.splice(index, 1);
            this.isSelectAll = false;
            this.$forceUpdate();
        } else {
            item.isSelect = true;
            this.chooseInvoiceArr.push(item);
            if (this.chooseInvoiceArr.length == 1 && this.payInvoice.length == 1) {
                this.payInvoice = [];
            }
            this.payInvoice.push(item);
            this.$forceUpdate();
        }
    }

    chooseAllInvoice() {
        this.chooseInvoiceArr = [];
        this.payInvoice = [];
        if (!this.isSelectAll) {
            forEach(this.invoicesArr, item => {
                item.isSelect = true;
            });
            forEach(this.invoicesArr, item => {
                if (item.status == 1 || item.status == 3) {
                    this.chooseInvoiceArr.push(item);
                    this.payInvoice.push(item);
                }
            });
        } else {
            forEach(this.invoicesArr, item => {
                item.isSelect = false;
            });
            this.chooseInvoiceArr = [];
            this.payInvoice = [];
        }
        this.$forceUpdate();
    }

    makePayment(item: any) {
        this.orderId = item.order_id;
        forEach(this.invoicesArr, item => {
            item.isSelect = false;
        });
        this.isSelectAll = false;
        this.payInvoice = [];
        this.payInvoice.push(item);
        this.payOptionVal = 1;
        this.payTitle = 'Pay for selected invoices';
        this.$modal.show(this.editProductModal);
    }

    paySelectInvoice() {
        this.payOptionVal = 1;
        this.payTitle = 'Pay for selected invoices';
        this.$modal.show(this.editProductModal);
    }

    payAllOutstanding() {
        this.payInvoice = [];
        this.payOptionVal = 2;
        forEach(this.invoicesArr, item => {
            item.isSelect = false;
        });
        this.isSelectAll = false;
        this.$forceUpdate();
        this.payTitle = 'Pay all outstanding';
        this.$modal.show(this.editProductModal);
    }

    showOptions(index: any) {
        this.invoicesArr[index].showOption = !this.invoicesArr[index].showOption;
        this.$forceUpdate();
    }

    chargeSuccess() {
        this.closeModal();
        this.showUpdated({ title: 'Pay Result', mag: 'Pay successfully' });
        this.searchParams.page = 1;
        this.getInvoicesList(this.searchParams.page);
        this.getAllOutStanding();
    }

    exportPdf(url: string) {
        window.open(url);
        analytics.trackFileDownload({ fileName: 'invoice_pdf', fileType: 'pdf' });
    }

    viewShipment(id: any) {
        this.$router.replace({
            name: 'ViewShipment',
            params: {
                id: id,
            },
        });
    }

    shipmentView(id: any) {
        localStorage.setItem('ShipmentViewFrom', '1');
        this.$router.push({
            name: 'ShipmentView',
            params: {
                orderId: id,
                from: '2',
            },
        });
    }

    tagFoldBody(foldName: any) {
        if (this.foldBody == foldName) this.foldBody = 0;
        else this.foldBody = foldName;
    }

    sortByDueDate() {
        this.sortStatus = 0;
        this.sortDueDate++;
        if (this.sortDueDate > 2) {
            this.sortDueDate = 0;
        }
        if (this.sortDueDate == 0) {
            delete this.searchParams.order_by;
        } else {
            this.searchParams.order_by = 'due_date';
        }
        this.sort(this.sortDueDate);
    }
    sortByStatus() {
        this.sortDueDate = 0;
        this.sortStatus++;
        if (this.sortStatus > 2) {
            this.sortStatus = 0;
        }
        if (this.sortStatus == 0) {
            delete this.searchParams.order_by;
        } else {
            this.searchParams.order_by = 'status';
        }
        this.sort(this.sortStatus);
    }

    sort(num: any) {
        const TmsInvoiceSortByOrder = {
            ASC: 4,
            DESC: 3,
        };
        if (num == 1) {
            this.searchParams.sort = TmsInvoiceSortByOrder.ASC;
        } else if (num == 2) {
            this.searchParams.sort = TmsInvoiceSortByOrder.DESC;
        }
        this.getInvoicesList(this.searchParams.page);
    }

    onStatusArr(stage: any) {
        this.fromStatusArray = null;
    }

    async getCustomerData() {
        await switchBillingToService
            .post()
            .then((res: any) => {
                if (res.data.billing != undefined && res.data.billing.location_id) {
                    this.billto_id = res.data.billing.location_id;
                } else {
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        localStorage.removeItem(util.Base64EncodetoString('AddPayMents'));
        next();
    }

    async exportData() {
        const params = {
            ...this.searchParams,
        };

        params.status_array = [];
        if (this.isGetInvoicesListByStatusArray) {
            params.status_array = this.fromStatusArray;
        } else {
            params.status_array = [];
            if (this.fromStatusArray && this.fromStatusArray.length > 0) {
                params.status_array = this.fromStatusArray;
            } else if (this.searchStatus && this.searchStatus != 'all') {
                params.status_array.push(this.searchStatus);
            }
        }

        const fields: string[] = [];
        this.supportedFields.forEach(i => {
            // @ts-ignore
            if (this.showFields[i.key] === true) {
                fields.push(i.field);
            }
        });
        params.fields = fields;
        params.page = 1;
        params.page_size = 99999;

        try {
            this.isExportingData = true;
            const res = await tmsServiceBackend.get(
                `/tms/invoices/export?${qs.stringify(params)}`,
                {
                    responseType: 'blob',
                }
            );
            const headers = res.headers || {};
            const dispositions = /attachment; filename="(.*)"/i.exec(
                headers['content-disposition'] || ''
            );
            const filename = dispositions ? dispositions[1] : 'invoices.xls';
            download(filename, res.data);
            analytics.trackFileDownload({ fileName: 'invoices_export', fileType: 'xls' });
        } catch (error) {
            console.error(error);
        } finally {
            this.isExportingData = false;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/invoices/index.ts